import * as PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import deleteIcon from '../../../../../../svg/icons/delete.svg';
import editIcon from '../../../../../../svg/icons/edit.svg';
import Button from '../../../../../UI/Button/Button';
import {showOverlay} from '../../../../actions/overlay-actions';
import Translation from '../../../../lang/Translation';
import Spacing from '../../../../style-helper/Spacing';
import doMetric from '../../../../tracking/bigQueryMetricRecorder';
import Track from '../../../../utils/tracking';
import AddressAsText from '../../../address/AddressAsText/AddressAsText';
import {TooltipAndOverlayIDs} from '../../../detailed-tooltip/TooltipLibrary';
import CheckoutOverlay from '../../CheckoutOverlay';

const useStyles = createUseStyles({
  contentWrapper: {
    padding: [Spacing.quad, Spacing.double],
  },
  addressContainer: {
    backgroundColor: '#f2f2f2',
    padding: Spacing.double,
  },
  iconContainer: {
    padding: [Spacing.quad, 0],
  },
  iconLine: {
    display: 'flex',
    marginTop: Spacing.triple,
  
    '&:first-child': {
      marginTop: 0,
    },
  },
  iconText: {
    marginLeft: Spacing.double,
  },
});

export function EditDeleteAddressOverlay(props) {
  const classes = useStyles();
  
  const handleClick = (overlayId) => {
    props.showOverlay(overlayId, props);
    try {
      doMetric('selectEditDeleteAddress', [{name: 'overlay', value: overlayId}]);
    } catch (error) {
      Track.track(error);
    }
  };
  
  return (
    <CheckoutOverlay
      popup
      stickyScaleToContentMobile
      ordersummary
      nopadding
      minHeight
      title="checkout.delivery.editDeleteAddress.overlay.title"
      className={classes.overlay}
    >
      <div className={classes.contentWrapper}>
        <div className={classes.addressContainer}>
          <AddressAsText
            {...props.fieldValues}
            addressId={props.addressId}
          />
        </div>
        <div className={classes.iconContainer}>
          <span className={classes.iconLine}>
            <img src={editIcon} alt={Translation.getText('checkout.delivery.editDeleteAddress.overlay.edit.altText')} />
            <Button
              link
              leftAlign
              noResize
              id="editAddress"
              onClick={() => handleClick(TooltipAndOverlayIDs.EDIT_ADDRESS)}
              className={classes.iconText}
            >
              <Translation>checkout.delivery.editDeleteAddress.overlay.edit</Translation>
            </Button>
          </span>
          <span className={classes.iconLine}>
            <img
              src={deleteIcon}
              alt={Translation.getText('checkout.delivery.editDeleteAddress.overlay.delete.altText')}
            />
            <Button
              link
              leftAlign
              noResize
              id="deleteAddress"
              onClick={() => handleClick(TooltipAndOverlayIDs.DELETE_ADDRESS)}
              className={classes.iconText}
            >
              <Translation>checkout.delivery.editDeleteAddress.overlay.delete</Translation>
            </Button>
          </span>
        </div>
      </div>
    </CheckoutOverlay>
  );
}

EditDeleteAddressOverlay.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldValues: PropTypes.object.isRequired,
  addressId: PropTypes.string.isRequired,
  
  // Actions
  showOverlay: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  fieldValues: state.address.deliveryAddressList.addresses[ownProps.addressId],
  addresses: state.address.deliveryAddressList.addresses,
});

export default connect(mapStateToProps, {showOverlay})(EditDeleteAddressOverlay);
